import React, { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import ItensPedido from "../Shared/Interfaces/ItensPedido";
import { formatToBRL } from "../../Utils/utils";
import Pedido from "../Shared/Interfaces/Pedido";
//import { FormaPagamentoold, QuantidadeParcelas } from "../Shared/Constantes";
import DefaultLoader from "../Shared/DefaultLoader";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { AppProvider } from "../../ContextApi/AppProvider";
import IPagamentosPedido from "../Shared/Interfaces/PagamentosPedido";
import { FormaPagamentoService } from "../../Services/FormaPagamentoService";
import type { FormaPagamento } from "../Shared/Interfaces/FormaPagamento";
import { Parcela } from "../Shared/Interfaces/Parcela";
import { ParcelaService } from "../../Services/ParcelaService";
// Confirm Modal styles
const confirmModalStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

interface PedidoModalProps {
  open: boolean;
  onClose: () => void;
  onConcluir: (valorTotal: number) => void;
  onObservacoesChange?: (value: string) => void;
  pedido: Pedido;
  loading: boolean;
}

const PedidoModalResumo: React.FC<PedidoModalProps> = ({
  open,
  onClose,
  onConcluir,
  onObservacoesChange,
  pedido,
  loading,
}) => {
  const contextApi = useContext(AppProvider);
  const [formaPagamento, setFormaPagamento] = useState<FormaPagamento>();
  const [quantidadeParcelas, setQuantidadeParcelas] = useState(0);
  const [valorFormaPagamento, setValorFormaPagamento] = useState(0);
  const [pagamentoToEdit, setPagamentoToEdit] =
    useState<IPagamentosPedido | null>(null);
  const [novoValorParcela, setNovoValorParcela] = useState(0);
  const [formasPagamento, setFormasPagamento] = useState<FormaPagamento[]>([]);
  const [parcelasnovo, setParcelasNovo] = useState<Parcela[]>([]);
  const formaPagamentoService = new FormaPagamentoService();
  const parcelaService = new ParcelaService();
  const [pagamentosPedido, setPagamentosPedido] = React.useState<
    IPagamentosPedido[]
  >([]);
  const [saldoPedido, setSaldoPedido] = useState(0);
  const [totalGeral, setTotalGeral] = useState(0);
  const [observacoes, setObservacoes] = useState("");

  // Modal for confirmation
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedPagamento, setSelectedPagamento] =
    useState<IPagamentosPedido | null>(null);

  const [itensPedidoAuxiliar, setItensPedidoAuxiliar] = useState<ItensPedido[]>(
    pedido.itensPedido
  );
  const [valorTotalAuxiliar, setValorTotalAuxiliar] = useState(
    pedido.valorTotal
  );

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    width: { xs: "95vw", md: 800 },
    height: "auto",
    transform: "translate(-50%, -50%)",
    maxWidth: "95vw",
    maxHeight: "80vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 2, sm: 4 },
    overflowX: "hidden",
  };

  const getAllFormasPagamento = async () => {
    try {
      const response = await formaPagamentoService.getAll();
      setFormasPagamento(response.data);
    } catch (e) {
      contextApi.showMessage("Erro ao buscar formas de pagamento", true, "error");
    } 
  };

  const getAllParcelas = async () => {
    try {
      const response = await parcelaService.getAll();
      setParcelasNovo(response.data);
    } catch (e) {
      contextApi.showMessage("Erro ao buscar parcelas", true, "error");
    } 
  };

  const carregaAuxiliares = () => {
    setItensPedidoAuxiliar(pedido.itensPedido);
    setValorTotalAuxiliar(pedido.valorTotal);
    setTotalGeral(pedido.valorTotal);
    setPagamentosPedido(pedido.pagamentosPedido);
    setObservacoes(pedido.observacoes || "");
    
    let valorTotal = pedido.valorTotal;

    if (pedido.pagamentosPedido.length > 0) {
        pedido.pagamentosPedido.forEach((pagamento) => {
    let valor = pagamento.valorTotal;

    if (pagamento.formaPagamento === 'Débito') {
      let taxa = formasPagamento.find((element) => element.descricao == 'Débito')?.taxa;
      //valor = valor / 1.0186; // Aplica o desconto de 1,86%
      if(taxa !== undefined)
          valor = valor / taxa;
    }

    valorTotal -= valor;
  });

  setSaldoPedido(Number(valorTotal.toFixed(2)));
} else {
  setSaldoPedido(Number(valorTotal.toFixed(2)));
}

  };

  const handleRemoveFormaPagamento = (pagamento: IPagamentosPedido) => {
    setOpenConfirmModal(true);
    setSelectedPagamento(pagamento);
  };

  const openEditModalValorParcela = (pagamento: IPagamentosPedido) => {
    setPagamentoToEdit(pagamento);
    setNovoValorParcela(pagamento.valorParcela);
    setOpenEditModal(true);
  };

  const openEditModalValorDebito = (pagamento: IPagamentosPedido) => {
    setPagamentoToEditDebito(pagamento);
    setNovoValorDebito(pagamento.valorTotal)
    setOpenEditModalDebito(true);
  };



  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditModalDebito, setOpenEditModalDebito] = useState(false);
  const [pagamentoToEditDebito, setPagamentoToEditDebito] = useState<IPagamentosPedido | null>(null);
  const [novoValorDebito, setNovoValorDebito] = useState(0);
  
  const confirmRemovePagamento = () => {
    if (selectedPagamento) {
      const novosPagamentos = pagamentosPedido.filter(
        (pagamentoPedido) => pagamentoPedido.id !== selectedPagamento.id
      );

      if(selectedPagamento.formaPagamento == 'Débito'){
        selectedPagamento.valorTotal = selectedPagamento.valorTotal / 1.0186
      }

      setPagamentosPedido(novosPagamentos);
      setSaldoPedido((prevSaldo) => prevSaldo + selectedPagamento.valorTotal);
      // Atualiza o objeto recebido por parâmetro (mutável)
      pedido.pagamentosPedido = novosPagamentos;
      setOpenConfirmModal(false);
    }
  };

  const cancelarRemocaoPagamento = () => {
    setOpenConfirmModal(false);
    setSelectedPagamento(null);
  };

  const CalculoCreditoParcelado = (
    formaPagamento: string,
    quantidadeParcelas: number
  ): IPagamentosPedido => {
    const valorParaCalculo = valorFormaPagamento;
    setSaldoPedido(saldoPedido - valorParaCalculo);
    let valorTotal = 0;
    let valorParcela = 0;

    const parcelaSelecionada = parcelasnovo.find(
      (p) => p.quantidadeParcelas === quantidadeParcelas
    );
    pedido.quantidadeParcelas = parcelaSelecionada?.quantidadeParcelas ?? 0;

    if (parcelaSelecionada) {
      const taxa = parcelaSelecionada.taxa / 100;
      valorTotal = valorParaCalculo * (1 + taxa);
      valorParcela = valorTotal / quantidadeParcelas;
      valorParcela = parseFloat(valorParcela.toFixed(2));
    }

    return {
      id: pagamentosPedido.length + 1,
      valorTotal: valorFormaPagamento,
      formaPagamento,
      quantidadeParcelas,
      valorParcela,
    };
  };

  const handleChange = (value: string) => {
    const unformattedValue = value.replace(/\D/g, "");
    // Convert to a number and divide by 100 for cents
    const numericValue = Number(unformattedValue) / 100;
    setValorFormaPagamento(numericValue);
  };

  const handleChangeValorParcela = (value: string) => {
    const unformattedValue = value.replace(/\D/g, "");
    // Convert to a number and divide by 100 for cents
    const numericValue = Number(unformattedValue) / 100;
    setNovoValorParcela(numericValue);
  };

  const handleChangeValorDebito = (value: string) => {
    const unformattedValue = value.replace(/\D/g, "");
    // Convert to a number and divide by 100 for cents
    const numericValue = Number(unformattedValue) / 100;
    setNovoValorDebito(numericValue);
  };

  const aplicarFormaPagamento = (formaPagamento: FormaPagamento) => {
    setFormaPagamento(formaPagamento);
    if (formaPagamento.descricao !== "Crédito") {
      setTotalGeral(valorTotalAuxiliar);
      // Resetting the original item list
      pedido.itensPedido = [...itensPedidoAuxiliar];
      pedido.valorTotal = valorTotalAuxiliar;
      pedido.quantidadeParcelas = 0;
    }
  };
  
  const adicionarFormaDepagamento = (formaPagamento: FormaPagamento) => {
    if (valorFormaPagamento === 0) {
      contextApi.showMessage(
        "Informe valor para a forma de pagamento",
        true,
        "warning"
      );
      return;
    }

    if (valorFormaPagamento > saldoPedido) {
      contextApi.showMessage(
        "Valor Informado é maior que o saldo!",
        true,
        "warning"
      );
      return;
    }

    if (formaPagamento.descricao === "") {
      contextApi.showMessage("Informe a forma de pagamento", true, "warning");
      return;
    }

    if (formaPagamento.descricao === "Crédito") {
      const pagamento = CalculoCreditoParcelado(
        formaPagamento.descricao,
        quantidadeParcelas
      );
      pedido.pagamentosPedido.push(pagamento);
      setPagamentosPedido(pedido.pagamentosPedido);
      setSaldoPedido(saldoPedido - valorFormaPagamento);
    }  
    else {
      const pagamento: IPagamentosPedido = {
        id: pagamentosPedido.length + 1,
        valorTotal:  formaPagamento.descricao === 'Débito' ? valorFormaPagamento * (1 + 0.0186 ) : valorFormaPagamento,
        quantidadeParcelas: 0,
        valorParcela: 0,
        formaPagamento: formaPagamento.descricao,
      };
      pedido.pagamentosPedido.push(pagamento);
      setSaldoPedido(saldoPedido - valorFormaPagamento);
      setPagamentosPedido(pedido.pagamentosPedido);
    }
    setFormaPagamento(formaPagamento);
    setValorFormaPagamento(0);
    setQuantidadeParcelas(0);
  };

  useEffect(() => {
    if (open) {
      setTotalGeral(0);
      carregaAuxiliares();
      getAllFormasPagamento();
      getAllParcelas();

    }
  }, [open]);

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2">
            Resumo do Pedido
          </Typography>
          <Typography sx={{ mt: 2 }}>
            <b>Cliente:</b> {pedido.cliente.nome}
          </Typography>
          <Typography sx={{ mt: 2 }}>
            <b>Produtos:</b>
          </Typography>
          <ul>
            {pedido.itensPedido.map((item) => (
              <li key={item.idProduto}>
                {item.descricao} - Qtd: {item.quantidade} - Preço:
                {formatToBRL(item.preco)}- Total: {formatToBRL(item.valorTotal)}
              </li>
            ))}
          </ul>
          <Typography sx={{ mt: 2 }}>
            <b>Total Pedido:</b> {formatToBRL(totalGeral)}
          </Typography>
          <Typography
            sx={{
              color: saldoPedido > 0 ? "red" : "blue",
              mt: 2,
            }}
          >
            <b>Saldo:</b> {formatToBRL(saldoPedido)}
          </Typography>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={3}>
              <b>Forma de Pagamento:</b>
            </Grid>
            <Grid item xs={12} md={4} sx={{ minWidth: 0 }}>
              <Autocomplete
                disablePortal
                size="small"
                options={formasPagamento}
                getOptionLabel={(option) => option.descricao}
                onChange={(event, newValue) => {
                  if (newValue) {
                    aplicarFormaPagamento(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Forma Pagamento" fullWidth />
                )}
              />
            </Grid>
            {formaPagamento?.descricao === "Crédito" && (
              <Grid item xs={12} md={2} sx={{ minWidth: 0 }}>
                <Autocomplete
                  disablePortal
                  size="small"
                  options={parcelasnovo}
                  onChange={(event, newValue) => {
                    // if (newValue == null) {
                    //   aplicarQuantidadesParcelas('', 0);
                    // }
                    // aplicarQuantidadesParcelas(formaPagamento, newValue?.parcelas || 0);
                    if (newValue == null) {
                      setQuantidadeParcelas(0);
                    }
                    setQuantidadeParcelas(newValue?.quantidadeParcelas || 0);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Qtd. Parcelas" fullWidth />
                  )}
                />
              </Grid>
            )}
            <Grid item xs={12} md={2}>
              <TextField
                id="outlined-basic"
                label="Valor"
                variant="outlined"
                size="small"
                fullWidth
                value={formatToBRL(valorFormaPagamento)} // Display formatted BRL string
                onChange={(e) => handleChange(e.target.value)} // Keep raw value
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <Button
                variant="contained"
                disabled={loading}
                size="medium"
                sx={{ width: { xs: "100%", md: "auto" } }}
                onClick={() => formaPagamento && adicionarFormaDepagamento(formaPagamento)}
              >
                <AddIcon></AddIcon>
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Box component="ul" sx={{ m: 0, pl: 2 }}>
                {pagamentosPedido.map((pagamento) =>
                  pagamento.formaPagamento === "Crédito" ? (
                    <li key={pagamento.id}>
                      {pagamento.formaPagamento} {pagamento.quantidadeParcelas}x:{" "}
                      {formatToBRL(pagamento.valorParcela)}
                      <EditIcon
                        fontSize="small"
                        sx={{ color: "blue" }}
                        onClick={() => openEditModalValorParcela(pagamento)}
                      />
                      <DeleteOutlineIcon
                        fontSize="small"
                        sx={{ color: "red" }}
                        onClick={() => handleRemoveFormaPagamento(pagamento)}
                      />
                    </li>
                  ) : (
                    <li key={pagamento.id}>
                      {pagamento.formaPagamento}: {formatToBRL(pagamento.valorTotal)}
                      {pagamento.formaPagamento === "Débito" && (
                        <EditIcon
                          fontSize="small"
                          sx={{ color: "blue", cursor: "pointer", ml: 1 }}
                          onClick={() => openEditModalValorDebito(pagamento)}
                        />
                      )}
                      <DeleteOutlineIcon
                        fontSize="small"
                        sx={{ color: "red" }}
                        onClick={() => handleRemoveFormaPagamento(pagamento)}
                      />
                    </li>
                  )
                )}
              </Box>
            </Grid>
          </Grid>

          <TextField
            label="Observações"
            fullWidth
            multiline
            minRows={3}
            sx={{ mt: 2 }}
            value={observacoes}
            onChange={(e) => {
              const value = e.target.value;
              setObservacoes(value);
              pedido.observacoes = value;
              onObservacoesChange?.(value);
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
            <Button variant="contained" onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant="contained"
              disabled={loading || saldoPedido != 0}
              onClick={() => onConcluir(totalGeral)}
            >
              {loading ? (
                <DefaultLoader
                  height="3em"
                  width="3em"
                  colors={[
                    "#1876D2",
                    "#1876D2",
                    "#1876D2",
                    "#1876D2",
                    "#1876D2",
                  ]}
                  textInfo="Gerando pedido"
                />
              ) : (
                "Concluir"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Confirmation Modal */}
      <Modal open={openConfirmModal} onClose={cancelarRemocaoPagamento}>
        <Box sx={confirmModalStyle}>
          <Typography variant="h6" component="h2">
            Confirmar Remoção
          </Typography>
          <Typography sx={{ mt: 2 }}>
            Tem certeza que deseja remover a forma de pagamento?
          </Typography>
          <Box sx={{ mt: 2 }}>
            <Button
              onClick={confirmRemovePagamento}
              variant="contained"
              color="primary"
            >
              Confirmar
            </Button>
            <Button
              onClick={cancelarRemocaoPagamento}
              variant="outlined"
              sx={{ ml: 2 }}
            >
              Cancelar
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
        <Box sx={confirmModalStyle}>
          <Typography variant="h6">Editar Valor da Parcela</Typography>
          <TextField
            label="Novo Valor da Parcela"
            value={formatToBRL(novoValorParcela)}
            onChange={(e) => handleChangeValorParcela(e.target.value)}
            fullWidth
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              onClick={() => {
                if (pagamentoToEdit) {
                  const updatedPagamentos = pagamentosPedido.map((pagamento) =>
                    pagamento.id === pagamentoToEdit.id 
                      ? { ...pagamento, valorParcela: novoValorParcela }
                      : pagamento
                  );
                
                  setPagamentosPedido(updatedPagamentos);
                  pedido.pagamentosPedido = updatedPagamentos;
                  setOpenEditModal(false);
                }
              }}
            >
              Confirmar
            </Button>
            <Button variant="outlined" onClick={() => setOpenEditModal(false)}>
              Cancelar
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal para editar valor do pagamento em débito */}
      <Modal open={openEditModalDebito} onClose={() => setOpenEditModalDebito(false)}>
        <Box sx={confirmModalStyle}>
          <Typography variant="h6">Editar Valor do Pagamento em Débito</Typography>
          <TextField
            label="Novo Valor"
            value={formatToBRL(novoValorDebito)}
            onChange={(e) => handleChangeValorDebito(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              onClick={() => {
                if (pagamentoToEditDebito) {
                  const updatedPagamentos = pagamentosPedido.map((pagamento) =>
                    pagamento.id === pagamentoToEditDebito.id 
                      ? { ...pagamento, valorTotal: novoValorDebito }
                      : pagamento
                  );
                
                  setPagamentosPedido(updatedPagamentos);
                  pedido.pagamentosPedido = updatedPagamentos;
                  
                  setOpenEditModalDebito(false);
                }
              }}
            >
              Confirmar
            </Button>
            <Button variant="outlined" onClick={() => setOpenEditModalDebito(false)}>
              Cancelar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PedidoModalResumo;
